<template>
  <span class="badge badge-pill" :class="classStatus">
    {{ statusName }}
  </span>
</template>

<script>
export default {
  name: "DesignAssignStatus",
  props: {
    status: Number
  },
  computed: {
    statusName() {
      switch (this.status) {
        case 0:
          return "Not Available";
        case 1:
          return "Assigned";
        case 2:
          return "Designing";
        case 3:
          return "Rejected";
        case 4:
          return "Available";
        default:
          return "Not Available";
      }
    },
    classStatus() {
      switch (this.status) {
        case 0:
          return 'badge-default';
        case 1:
          return 'badge-warning';
        case 2:
          return 'badge-cyan';
        case 3:
          return 'badge-primary';
        case 4:
          return 'badge-success';
        default:
          return 'badge-default';
      }
    },
  }
}
</script>